import {mkConfig, generateCsv, download} from "export-to-csv";
import {Formatter} from "@/core/services/formatter.service";
import {store} from './../../../plugins/vuex/index'
import i18n from "@/shared/i18n";

function getCreatedData(item) {
  return `${Formatter.toDate(item.created_at)} by ${item.created_by.display_name}`
}

function getUpdatedData(item) {
  return `${Formatter.toDate(item.updated_at)} by ${item.updated_by.display_name}`
}

class ArtisioTableExportHelper {
  currentVueComponent = null;

  customerGetter = {
    filename: 'Customer Export',
    no: (item) => {
      return item.no
    },
    full_name: (item) => {
      return item.display_name
    },
    company_name: (item) => {
      return item.company_name
    },
    email: (item) => {
      return item.email
    },
    address: (item) => {
      return item.display_billing_address
    },
    phone: (item) => {
      return item.phone
    },
    status: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.status))
    },
    account_managers: (item) => {
      if (item.account_managers && item.account_managers.length > 0) {
        return item.account_managers[0].display_name
      }
      return ''
    },
    optin: (item) => {
      return item.optin
    },
    tags: (item) => {
      return item.tags
    },
    is_company: (item) => {
      return item.is_company
    },
    sms_optin: (item) => {
      return item.sms_optin
    },
    mark_optin: (item) => {
      return item.mark_optin
    },
    personal_id: (item) => {
      return item.personal_id
    },
    shipping_address: (item) => {
      return item.display_shipping_address
    },
    enable_estimate_request: (item) => {
      return item.enable_estimate_request
    },
    birth_date: (item) => {
      return item.birth_date
    },
    is_vendor: (item) => {
      return item.is_vendor
    },
    gender: (item) => {
      return item.gender
    },
    accounting_code: (item) => {
      return item.accounting_code
    },
    type: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.type))
    },
    created_data: (item) => {
      return `${Formatter.toDate(item.created_at)} by ${item.created_by.display_name}`
    },
    updated_data: (item) => {
      return `${Formatter.toDate(item.updated_at)} by ${item.updated_by.display_name}`
    },
    credit_card_verified_at: (item) => {
      return item.credit_card_verified_at ? Formatter.toDate(item.credit_card_verified_at) : ''
    },
    personal_identification_number: (item) => {
      return item.identification ? item.identification.personal_identification_number : '';
    },
    document_type: (item) => {
      return item.identification ? Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.identification.document_type)) : '';
    },
    document_number: (item) => {
      return item.identification ? item.identification.document_number : '';
    },
    document_issue_date: (item) => {
      return item.identification && item.identification.document_issue_date ? Formatter.toDate(item.identification.document_issue_date) : '';
    },
    document_expiry_date: (item) => {
      return item.identification && item.identification.document_expiry_date ? Formatter.toDate(item.identification.document_expiry_date) : '';
    },
    date_of_birth: (item) => {
      return item.identification && item.identification.date_of_birth ? Formatter.toDate(item.identification.date_of_birth) : '';
    },
    citizenship_code: (item) => {
      if (item.identification && item.identification.citizenship_code) {
        return store.getters['global/countryMap'][item.identification.citizenship_code]
      }
      return ''
    },
    residency_code: (item) => {
      if (item.identification && item.identification.residency_code) {
        return store.getters['global/countryMap'][item.identification.residency_code]
      }
      return ''
    },
    country_of_birth_code: (item) => {
      if (item.identification && item.identification.country_of_birth_code) {
        return store.getters['global/countryMap'][item.identification.country_of_birth_code]
      }
      return ''
    },
    place_of_issue: (item) => {
      return item.identification ? item.identification.place_of_issue : '';
    },
    company_reg_number: (item) => {
      return item.identification ? item.identification.company_reg_number : '';
    },
    dynamicFieldGet: (item, field) => {
      let dfValue = item.dynamic_fields[field.key]
      return this.currentVueComponent.$options.filters.asDynamicField(dfValue, field.type, field.choices, true)
    },
    vendor_lead_status: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.vendor_lead_status));
    },
    buyer_lead_status: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.buyer_lead_status));
    },
    identity_verification: (item) => {
      return item.term.identity_verification;
    },
    kyc_status_verified: (item) => {
      return item.term.kyc_status_verified;
    },
    exclude_from_auto_payments: (item) => {
      return item.term.exclude_from_auto_payments;
    },
  }

  receiptGetter = {
    filename: 'Receipt Export',
    receipt_no: (item) => {
      return item.receipt_no
    },
    customer: (item) => {
      return item.customer ? item.customer.display_name : ''
    },
    date: (item) => {
      return Formatter.toDate(item.date)
    },
    description: (item) => {
      return item.description
    },
    items: (item) => {
      return item.total_items
    },
    reserve: (item) => {
      return item.total_reserve
    },
    department: (item) => {
      if (item.department) {
        return this.currentVueComponent.$options.filters.masterLanguage(item.department.name)
      }
      return ''
    },
    minimum_commission: (item) => {
      return item.minimum_commission
    },
    insurance_rate: (item) => {
      return item.insurance_rate
    },
    lot_handling_charge: (item) => {
      return item.lot_handling_charge
    },
    sold_items: (item) => {
      return item.sold_items
    },
    unsold_items: (item) => {
      return item.unsold_items
    },
    created_data: getCreatedData,
    updated_data: getUpdatedData,
    recommended_by_user: (item) => {
      if (item.recommended_by_user) {
        return item.recommended_by_user.display_name
      }
      return ''
    },
    rep_user: (item) => {
      if (item.rep_user) {
        return item.rep_user.display_name
      }
      return ''
    },
    specialists: (item) => {
      if (item.specialists) {
        return item.specialists.map(s => s.display_name).join(', ')
      }
      return ''
    },
    "customer.accounting_code": (item) => {
      return item.customer.accounting_code
    },
    receipt_contract_status: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.receipt_contract_status))
    },
    containers_count: (item) => {
      return item.containers_count
    },
    container_type: (item) => {
      return item.container_type
    },
    receipt_type: (item) => {
      return item.receipt_type
    },
    pre_receipt_contract_status: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.pre_receipt_contract_status))
    },
    item_location: (item) => {
      const itemLocationResults = [];
      item.item_locations.forEach((il) => {
        itemLocationResults.push(il.item_location.name + (il.container_type ? '- ' + il.container_type : ''))
      })
      return itemLocationResults.join('\n')
    },
    enable_multiple_locations: (item) => {
      return item.enable_multiple_locations ? i18n.t('Yes') : i18n.t('No');
    },
  }

  salesGetter = {
    filename: 'Sale Export',
    sale_no: (item) => {
      return item.sale_no
    },
    status: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.status))
    },
    start_date: (item) => {
      if (item.dates) {
        let returnStr = []
        for (let date of item.dates) {
          if (!date.end_date) {
            returnStr.push(`${Formatter.toDateTime(date.start_date)}`)
          } else {
            returnStr.push(`${Formatter.toDateTime(date.start_date)} - ${Formatter.toDateTime(date.end_date)}`)
          }
        }
        return returnStr.join('\n')
      }
      return ''
    },
    title: (item) => {
      return this.currentVueComponent.$options.filters.striptags(Formatter.getByMasterLanguage(item.title))
    },
    department: (item) => {
      if (item.department) {
        return this.currentVueComponent.$options.filters.masterLanguage(item.department.name)
      }
      return ''
    },
    currency: (item) => {
      return item.currency ? item.currency.code : '';
    },
    items: (item) => {
      return item.total_items
    },
    type: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.type))
    },
    live_reference: (item) => {
      return item.live_reference
    },
    payment_terms: (item) => {
      return item.payment_terms
    },
    settlement_days: (item) => {
      return item.settlement_days
    },
    reserved_items: (item) => {
      return item.reserved_items
    },
    total_lots: (item) => {
      return item.total_lots
    },
    estimate: (item) => {
      return `${item.low_estimate_amount} - ${item.high_estimate_amount}`
    },
    reserve: (item) => {
      return item.reserve_amount
    },
    sold_lots: (item) => {
      return item.sold_lots
    },
    unsold_lots: (item) => {
      return item.unsold_lots
    },
    created_data: (item) => {
      return getCreatedData(item)
    },
    updated_data: (item) => {
      return getUpdatedData(item)
    },
    after_sale_end_date: (item) => {
      return item.after_sale_end_date ? Formatter.toDateTime(item.after_sale_end_date) : ''
    },
    require_credit_card_verification: (item) => {
      return item.require_credit_card_verification
    },
    is_private(item) {
      return item.is_private ? 'Private' : 'Public'
    },
    dynamicFieldGet: (item, field) => {
      let dfValue = Formatter.getByMasterLanguage(item.dynamic_fields)[field.key]
      return this.currentVueComponent.$options.filters.asDynamicField(dfValue, field.type, field.choices, true)
    },
    require_identity_verification: (item) => {
      return item.require_identity_verification
    },
  }

  inventoryGetter = {
    filename: 'Inventory Export',
    stock_no: (item) => {
      return item.stock_no
    },
    title: (item) => {
      return this.currentVueComponent.$options.filters.striptags(item.short_description)
    },
    low: (item) => {
      return `${item.low} - ${item.high}`
    },
    quantity: (item) => {
      return item.quantity
    },
    reserve: (item) => {
      return item.reserve
    },
    receive_date: (item) => {
      return Formatter.toDate(item.receive_date)
    },
    tax_status: (item) => {
      return item.tax_status ? item.tax_status.name : ''
    },
    tax_rate: (item) => {
      return item.tax_rate
    },
    department: (item) => {
      if (item.department) {
        return this.currentVueComponent.$options.filters.masterLanguage(item.department.name)
      }
      return ''
    },
    category: (item) => {
      if (item.category) {
        return this.currentVueComponent.$options.filters.masterLanguage(item.category.name)
      }
      return ''
    },
    item_location: (item) => {
      return item.item_location ? item.item_location.name : ''
    },
    start_price: (item) => {
      return item.start_price
    },
    collection_info: (item) => {
      return item.collection_info_full
    },
    created_at: (item) => {
      return getCreatedData(item)
    },
    updated_at: (item) => {
      return getUpdatedData(item)
    },
    status: (item) => {
      return item.statuses && item.statuses.length > 0 ? Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.statuses[0].status)) : ''
    },
    account_managers: (item) => {
      if (item.account_managers && item.account_managers.length > 0) {
        return item.account_managers[0].display_name
      }
      return ''
    },
    available_quantity: (item) => {
      return item.available_quantity
    },
    company_name: (item) => {
      return item.customer ? item.customer.company_name : ''
    },
    collected: (item) => {
      return item.collected
    },
    collected_status: (item) => {
      if (item.collected_status && item.collected_status.length > 0) {
        let returnData = []
        for (let st of item.collected_status) {
          returnData.push(`${Formatter.removeUnderscores(Formatter.toUpperCaseFirst(st.status))} - ${st.quantity}`)
        }
        return returnData.join('\n')
      }
      return ''
    },
    lot_no: (item) => {
      return item.latest_reservation ? item.latest_reservation.lot_no : ''
    },
    hammer_price: (item) => {
      return item.latest_reservation ? item.latest_reservation.hammer_price : ''
    },
    reserve_type: (item) => {
      return Formatter.toUpperCaseFirst(Formatter.removeUnderscores(item.reserve_type))
    },
    specialists: (item) => {
      if (item.specialists) {
        return item.specialists.map(s => s.display_name).join(', ')
      }
      return ''
    },
    return_note_collector: (item) => {
      if (item.return_notes && item.return_notes.length > 0) {
        return item.return_notes[0].collector
      }
      return ''
    },
    condition_requests_count: (item) => {
      return item.condition_requests_count
    },
    condition_requests_sent: (item) => {
      return item.condition_requests_sent
    },
    cataloguing_lifecycle: (item) => {
      if (!item.cataloguing_lifecycle || !store.state.global.cataloguingLifecycleOptions) {
        return '';
      }
      const option = store.state.global.cataloguingLifecycleOptions.find(opt => opt.key === item.cataloguing_lifecycle);
      return option ? option.value : item.cataloguing_lifecycle;
    },
    photography_lifecycle: (item) => {
      if (!item.photography_lifecycle || !store.state.global.photographyLifecycleOptions) {
        return '';
      }
      const option = store.state.global.photographyLifecycleOptions.find(opt => opt.key === item.photography_lifecycle);
      return option ? option.value : item.photography_lifecycle;
    },
    customer: (item) => {
      return item.customer ? item.customer.display_name : ''
    },
    dynamicFieldGet: (item, field) => {
      let dfValue = Formatter.getByMasterLanguage(item.dynamic_fields)[field.key]
      return this.currentVueComponent.$options.filters.asDynamicField(dfValue, field.type, field.choices, true)
    }
  }

  invoiceGetter = {
    filename: 'Invoice Export',
    invoice_no: (item) => {
      return item.invoice_no
    },
    type: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.type))
    },
    sale_no: (item) => {
      return item.auction ? item.auction.sale_no : ''
    },
    customer_uuid: (item) => {
      return item.customer ? item.customer.display_name : ''
    },
    total_buyer_vat: (item) => {
      return item.total_buyer_vat
    },
    customer_company_name: (item) => {
      return item.customer ? item.customer.company_name : ''
    },
    amount: (item) => {
      return `${item.total_amount} / ${item.paid_amount} / ${item.outstanding_amount}`
    },
    total_amount: (item) => {
      return item.total_amount
    },
    paid_amount: (item) => {
      return item.paid_amount
    },
    outstanding_amount: (item) => {
      return item.outstanding_amount
    },
    items: (item) => {
      if (item.status === 'cancelled' || item.is_credited) {
        return item.data.total_lots;
      } else if (item.is_credit_note && item.credited_invoice) {
        return item.credited_invoice.data.total_lots;
      }
      return item.total_lots;
    },
    status: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.status))
    },
    date: (item) => {
      return Formatter.toDate(item.date)
    },
    shipping_status: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.shipping_status))
    },
    shipping_tracking_code: (item) => {
      return item.shipping_tracking_code
    },
    shipping_address_1: (item) => {
      return item.invoice_shipping_address ? item.invoice_shipping_address.address_1 : ''
    },
    shipping_address_2: (item) => {
      return item.invoice_shipping_address ? item.invoice_shipping_address.address_2 : ''
    },
    shipping_state: (item) => {
      return item.invoice_shipping_address ? item.invoice_shipping_address.state : ''
    },
    shipping_county: (item) => {
      return item.invoice_shipping_address ? item.invoice_shipping_address.county : ''
    },
    shipping_city: (item) => {
      return item.invoice_shipping_address ? item.invoice_shipping_address.city : ''
    },
    shipping_zip_code: (item) => {
      return item.invoice_shipping_address ? item.invoice_shipping_address.zip_code : ''
    },
    shipping_country: (item) => {
      return item.invoice_shipping_address && item.invoice_shipping_address.country ? item.invoice_shipping_address.country.name : ''
    },
    shipping_first_name: (item) => {
      return item.invoice_shipping_address ? item.invoice_shipping_address.first_name : ''
    },
    shipping_last_name: (item) => {
      return item.invoice_shipping_address ? item.invoice_shipping_address.last_name : ''
    },
    billing_address_1: (item) => {
      return item.invoice_billing_address ? item.invoice_billing_address.address_1 : ''
    },
    billing_address_2: (item) => {
      return item.invoice_billing_address ? item.invoice_billing_address.address_2 : ''
    },
    billing_state: (item) => {
      return item.invoice_billing_address ? item.invoice_billing_address.state : ''
    },
    billing_county: (item) => {
      return item.invoice_billing_address ? item.invoice_billing_address.county : ''
    },
    billing_city: (item) => {
      return item.invoice_billing_address ? item.invoice_billing_address.city : ''
    },
    billing_zip_code: (item) => {
      return item.invoice_billing_address ? item.invoice_billing_address.zip_code : ''
    },
    billing_country: (item) => {
      return item.invoice_billing_address && item.invoice_billing_address.country ? item.invoice_billing_address.country.name : ''
    },
    billing_first_name: (item) => {
      return item.invoice_billing_address ? item.invoice_billing_address.first_name : ''
    },
    billing_last_name: (item) => {
      return item.invoice_billing_address ? item.invoice_billing_address.last_name : ''
    },
    last_synced_at: (item) => {
      return Formatter.toDateTime(item.last_synced_at)
    },
    collected: (item) => {
      if (item.status === 'cancelled' || item.is_credited) {
        return item.data.total_collected_lots;
      } else if (item.is_credit_note && item.credited_invoice) {
        return item.credited_invoice.data.total_collected_lots;
      }
      return item.total_collected_lots;
    },
    complaint_status: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.complaint_status))
    },
    overdue_notification_send_at: (item) => {
      return item.overdue_notification_send_at ? Formatter.toDateTime(item.overdue_notification_send_at) : ''
    },
    unpaid_notification_send_at: (item) => {
      return item.unpaid_notification_send_at ? Formatter.toDateTime(item.unpaid_notification_send_at) : ''
    },
    is_overdue: (item) => {
      return item.is_overdue
    },
    payment_methods: (item) => {
      if (item.payment_methods && item.payment_methods.length > 0) {
        let returnData = []
        for (let pm of item.payment_methods) {
          returnData.push(Formatter.removeUnderscores(Formatter.toUpperCaseFirst(pm)))
        }
        return returnData.join(', ')
      }
      return ''
    },
    created_data: (item) => {
      return getCreatedData(item)
    },
    updated_data: (item) => {
      return getUpdatedData(item)
    },
    collection_info_contract_status: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.collection_info_contract_status))
    },
    approved: (item) => {
      return item.approved
    },
    paid_at: (item) => {
      return item.paid_at ? Formatter.toDateTime(item.paid_at) : ''
    },
    dynamicFieldGet: (item, field) => {
      let dfValue = item.dynamic_fields[field.key]
      return this.currentVueComponent.$options.filters.asDynamicField(dfValue, field.type, field.choices, true)
    },
    identity_verification: (item) => {
      if (item.customer && item.customer.term) {
        return item.customer.term.identity_verification;
      }
      return ''
    },
    kyc_status_verification: (item) => {
      if (item.customer && item.customer.term) {
        return item.customer.term.kyc_status_verification;
      }
      return ''
    },
    collector: (item) => {
      return item.collector
    },
    customer_email: (item) => {
      return item.customer ? item.customer.email : ''
    },
    exclude_from_auto_payments: (item) => {
      return item.exclude_from_auto_payments
    },
    collection_appointment_notification_sent_at: (item) => {
      return item.collection_appointment_notification_sent_at ? Formatter.toDateTime(item.collection_appointment_notification_sent_at) : ''
    },
    branch: (item) => {
      return item.branch.name;
    },
  }

  settlementGetter = {
    filename: 'Settlement Export',
    date: (item) => {
      return Formatter.toDate(item.date)
    },
    settlement_no: (item) => {
      return item.settlement_no
    },
    type: (item) => {
      return Formatter.toUpperCaseFirst(Formatter.removeUnderscores(item.type))
    },
    sale_no: (item) => {
      return item.auction ? item.auction.sale_no : ''
    },
    customer_uuid: (item) => {
      return item.customer ? item.customer.display_name : ''
    },
    total_vendor_vat: (item) => {
      if (item.status === 'cancelled') {
        return item.data.total_vendor_vat;
      }
      return item.total_vendor_vat;
    },
    customer_company_name: (item) => {
      return item.customer ? item.customer.company_name : ''
    },
    amounts: (item) => {
      return `${item.total_amount} / ${item.paid_amount} / ${item.outstanding_amount}`
    },
    total_items: (item) => {
      if (item.type === 'debit_note' && item.debited_settlement) {
        return item.debited_settlement.data.total_financial_items;
      }
      return item.total_financial_items;
    },
    status: (item) => {
      return Formatter.toUpperCaseFirst(Formatter.removeUnderscores(item.status))
    },
    last_synced_at: (item) => {
      return item.last_synced_at ? Formatter.toDateTime(item.last_synced_at) : ''
    },
    created_data: (item) => {
      return getCreatedData(item)
    },
    updated_data: (item) => {
      return getUpdatedData(item)
    },
    receipts: (item) => {
      if (item.receipts && item.receipts.length > 0) {
        let data = []
        for (let r of item.receipts) {
          data.push(r.receipt_no)
        }
        return data.join(', ')
      }
      return ''
    },
    contact_person_for_settlement: (item) => {
      return item.contact_person_for_settlement ? item.contact_person_for_settlement.display_name : ''
    },
    notification_sent_at: (item) => {
      return item.notification_sent_at ? Formatter.toDateTime(item.notification_sent_at) : ''
    },
    identity_verification: (item) => {
      if (item.customer && item.customer.term) {
        return item.customer.term.identity_verification
      }
      return ''
    },
    kyc_status_verification: (item) => {
      if (item.customer && item.customer.term) {
        return item.customer.term.kyc_status_verification
      }
      return ''
    },
    total_amount: (item) => {
      return item.total_amount
    },
    paid_amount: (item) => {
      return item.paid_amount
    },
    outstanding_amount: (item) => {
      return item.outstanding_amount
    },
    branch: (item) => {
      return item.branch.name;
    },
  }

  lotGetter = {
    filename: 'Lot Export',
    item_no: (item) => {
      return item.inventory ? item.inventory.stock_no : ''
    },
    stock_no: (item) => {
      return item.inventory ? item.inventory.stock_no : ''
    },
    sale_no: (item) => {
      return item.auction ? item.auction.sale_no : ''
    },
    lot_no: (item) => {
      return item.lot_no
    },
    title: (item) => {
      return item.inventory ? item.inventory.short_description : ''
    },
    date: (item) => {
      let startDate = null;
      let endDate = null;

      if (store.state.global.enableContinuousAuction && item.auction && item.auction.dates && item.auction.dates.length) {
        startDate = item.auction.dates[0].start_date
        endDate = item.auction.dates[0].end_date
      } else if (item.auction) {
        startDate = item.auction.start_date
        endDate = item.auction.end_date
      }

      if (startDate && endDate) {
        return `${Formatter.toDateTime(startDate)} - ${Formatter.toDateTime(endDate)}`
      } else if (startDate) {
        return Formatter.toDateTime(startDate)
      }

      return ''
    },
    reserve: (item) => {
      return item.reserve
    },
    low: (item) => {
      return `${item.low} - ${item.high}`
    },
    quantity: (item) => {
      return item.quantity
    },
    hammer_price: (item) => {
      return item.lot ? item.lot.hammer_price : ''
    },
    winning_bidder: (item) => {
      if (item.lot && item.lot.bidder && item.lot.bidder.customer) {
        return item.lot.bidder.customer.display_name
      }
      return ''
    },
    negotiation_status: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.negotiation_status))
    },
    status: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.status))
    },
    settled: (item) => {
      return item.lot ? item.lot.settled : ''
    },
    invoice: (item) => {
      if (item.lot && item.lot.financial_item && item.lot.financial_item.invoice) {
        return item.lot.financial_item.invoice.invoice_no
      }
      return ''
    },
    customer: (item) => {
      if (item.inventory && item.inventory.customer) {
        return item.inventory.customer.display_name
      }
      return ''
    },
    account_managers: (item) => {
      if (item.account_managers && item.account_managers.length > 0) {
        return item.account_managers[0].display_name
      }
      return ''
    },
    created_data: (item) => {
      return getCreatedData(item)
    },
    updated_data: (item) => {
      return getUpdatedData(item)
    },

    recommended_by_user: (item) => {
      if (item.inventory && item.inventory.receipt && item.inventory.receipt.recommended_by_user) {
        return item.inventory.receipt.recommended_by_user.display_name
      }
      return ''
    },
    total_bids: (item) => {
      if (item.lot && item.lot.total_bids) {
        return item.lot.total_bids
      }
      return ''
    },
    winner_bid: (item) => {
      if (item.lot && item.lot.winner_bid) {
        return item.lot.winner_bid.amount
      }
      return ''
    },
    highest_bid: (item) => {
      if (item.lot && item.lot.highest_bid) {
        return item.lot.highest_bid.amount
      }
      return ''
    },
    collected: (item) => {
      return item.collected
    },
    registration_vrm: (item) => {
      return item.inventory ? Formatter.attributeByMasterLanguage(item.inventory.dynamic_fields, 'registration_vrm') : ''
    },
    start_price: (item) => {
      return item.start_price
    },
    department: (item) => {
      if (item.inventory && item.inventory.department) {
        return this.currentVueComponent.$options.filters.masterLanguage(item.inventory.department.name)
      }
      return ''
    },
    category: (item) => {
      if (item.inventory && item.inventory.category) {
        return this.currentVueComponent.$options.filters.masterLanguage(item.inventory.category.name)
      }
      return ''
    },
    auction_date_uuid: (item) => {
      if (item.lot && item.lot.auction_date) {
        return item.lot.auction_date.title
      }
      return ''
    },
    reserve_type: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.reserve_type))
    },
    auction_collection_uuid: (item) => {
      if (item.lot && item.lot.auction_collection) {
        return Formatter.attributeByMasterLanguage(item.lot.auction_collection, 'title')
      }
      return ''
    },
    specialists: (item) => {
      if (item.inventory && item.inventory.specialists) {
        return item.inventory.specialists.map(s => s.display_name).join(', ')
      }
      return ''
    },
    sold_via_negotiation: (item) => {
      return item.lot ? item.lot.sold_via_negotiation : ''
    },
    condition_requests_count: (item) => {
      return item.condition_requests_count
    },
    condition_requests_sent: (item) => {
      return item.condition_requests_sent
    },
    source_of_sale: (item) => {
      return item.lot ? Formatter.toUpperCaseEveryWord(Formatter.removeUnderscores(item.lot.source_of_sale)) : ''
    },
    dynamicFieldGet: (item, field) => {
      if (!item.inventory) {
        return ''
      }
      let dfValue = Formatter.getByMasterLanguage(item.inventory.dynamic_fields)[field.key]
      return this.currentVueComponent.$options.filters.asDynamicField(dfValue, field.type, field.choices, true)
    },
    cataloguing_lifecycle: (item) => {
      if (!item.inventory.cataloguing_lifecycle || !store.state.global.cataloguingLifecycleOptions) {
        return '';
      }
      const option = store.state.global.cataloguingLifecycleOptions.find(opt => opt.key === item.inventory.cataloguing_lifecycle);
      return option ? option.value : item.inventory.cataloguing_lifecycle;
    },
    photography_lifecycle: (item) => {
      if (!item.inventory.photography_lifecycle || !store.state.global.photographyLifecycleOptions) {
        return '';
      }
      const option = store.state.global.photographyLifecycleOptions.find(opt => opt.key === item.inventory.photography_lifecycle);
      return option ? option.value : item.inventory.photography_lifecycle;
    },
    hammer_bp_incl_vat: (item) => {
      if (item.lot && item.lot.financial_item) {
        return (parseFloat(item.lot.financial_item.hammer_bp_incl_vat) || 0);
      }
      return ''
    },
    receipt_contract_status: (item) => {
      if (item.inventory && item.inventory.receipt && item.inventory.receipt.receipt_contract_status) {
        return i18n.t(Formatter.toUpperCaseEveryWord(Formatter.removeUnderscores(item.inventory.receipt.receipt_contract_status)))
      }
      return ''
    },
    rep_user: (item) => {
      if (item.inventory && item.inventory.rep_user) {
        return item.inventory.rep_user.display_name
      }
    },
    item_location: (item) => {
      if (item.inventory && item.inventory.item_location) {
        return item.inventory.item_location.name
      }
      return ''
    },
    settlement: (item) => {
      if (item.lot && item.lot.financial_item && item.lot.financial_item.settlement) {
        return `${item.lot.financial_item.settlement.settlement_no} - ${i18n.t(Formatter.toUpperCaseEveryWord(Formatter.removeUnderscores(item.lot.financial_item.settlement.status)))}`;
      }
      return ''
    },
  }

  bidderGetter = {
    filename: 'Bidder Export',

    customer_uuid: (item) => {
      return item.customer ? item.customer.display_name : ''
    },
    customer_email: (item) => {
      return item.customer ? item.customer.email : ''
    },
    sale_no: (item) => {
      return item.auction ? item.auction.sale_no : ''
    },
    paddle_number: (item) => {
      return item.paddle_number
    },
    address: (item) => {
      return item.customer && item.customer.billing_address ? this.currentVueComponent.$options.filters.asAddress(item.customer.billing_address) : ''
    },
    company_name: (item) => {
      return item.customer ? item.customer.company_name : ''
    },
    preferred_clerk: (item) => {
      return item.preferred_clerk ? item.preferred_clerk.name : ''
    },
    language: (item) => {
      return item.language ? item.language.name : ''
    },
    total_spent: (item) => {
      return item.total_spent
    },
    date: (item) => {
      return item.date ? Formatter.toDateTime(item.date) : ''
    },
    status: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.status))
    },
    credit_card_verified_at: (item) => {
      return item.credit_card_verified_at ? Formatter.toDate(item.credit_card_verified_at) : ''
    },
    personal_identification_number: (item) => {
      return item.customer && item.customer.identification ? item.customer.identification.personal_identification_number : '';
    },
    document_type: (item) => {
      return item.customer && item.customer.identification ? Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.customer.identification.document_type)) : '';
    },
    document_number: (item) => {
      return item.customer && item.customer.identification ? item.customer.identification.document_number : '';
    },
    document_issue_date: (item) => {
      if (item.customer && item.customer.identification && item.customer.identification.document_issue_date) {
        return Formatter.toDate(item.customer.identification.document_issue_date)
      }
      return ''
    },
    document_expiry_date: (item) => {
      if (item.customer && item.customer.identification && item.customer.identification.document_expiry_date) {
        return Formatter.toDate(item.customer.identification.document_expiry_date)
      }
      return ''
    },
    date_of_birth: (item) => {
      if (item.customer && item.customer.identification && item.customer.identification.date_of_birth) {
        return Formatter.toDate(item.customer.identification.date_of_birth)
      }
      return ''
    },
    citizenship_code: (item) => {
      if (item.customer && item.customer.identification && item.customer.identification.citizenship_code) {
        return store.getters['global/countryMap'][item.customer.identification.citizenship_code]
      }
      return ''
    },
    residency_code: (item) => {
      if (item.customer && item.customer.identification && item.customer.identification.residency_code) {
        return store.getters['global/countryMap'][item.customer.identification.residency_code]
      }
      return ''
    },
    country_of_birth_code: (item) => {
      if (item.customer && item.customer.identification && item.customer.identification.country_of_birth_code) {
        return store.getters['global/countryMap'][item.customer.identification.country_of_birth_code]
      }
      return ''
    },
    place_of_issue: (item) => {
      return item.customer && item.customer.identification ? item.customer.identification.place_of_issue : '';
    },
    company_reg_number: (item) => {
      return item.customer && item.customer.identification ? item.customer.identification.company_reg_number : '';
    },
    dynamicFieldGet: (item, field) => {
      let dfValue = item.dynamic_fields[field.key]
      return this.currentVueComponent.$options.filters.asDynamicField(dfValue, field.type, field.choices, true)
    },
    trust_level: (item) => {
      let trustLevel = store.getters['global/trustLevels'].find(tr => tr.credit_limit === item.credit_limit)
      return trustLevel ? trustLevel.name : ''
    },
    total_purchases: (item) => {
      return item.total_purchases
    },
    identity_verification: (item) => {
      return (item.customer && item.customer.term) ? item.customer.term.identity_verification : ''
    },
    kyc_status_verified: (item) => {
      return (item.customer && item.customer.term) ? item.customer.term.kyc_status_verified : ''
    },
    customer_primary_phone: (item) => {
      return item.customer ? item.customer.primary_phone : ''
    },
  }

  bidGetter = {
    filename: 'Bid Export',
    bidder: (item) => {
      return item.bidder && item.bidder.customer ? item.bidder.customer.display_name : ''
    },
    stock_no: (item) => {
      return item.lot && item.lot.inventory ? item.lot.inventory.stock_no : ''
    },
    sale_no: (item) => {
      return item.auction ? item.auction.sale_no : ''
    },
    lot_no: (item) => {
      return item.lot ? item.lot.lot_no : ''
    },
    title: (item) => {
      return item.lot && item.lot.inventory ? item.lot.inventory.short_description : ''
    },
    amount: (item) => {
      return item.amount
    },
    date: (item) => {
      return item.date ? `${Formatter.toDate(item.date)} ${Formatter.toDate(item.date, 'HH:mm:ss')}` : ''
    },
    type: (item) => {
      return Formatter.removeUnderscores(Formatter.toUpperCaseFirst(item.type))
    },
    is_winner: (item) => {
      return item.is_winner
    },
    created_data: (item) => {
      return `${Formatter.toDate(item.created_at)} ${Formatter.toDate(item.created_at, 'HH:mm:ss')} by ${item.created_by.display_name}`
    },
  }

  vendorGetter = {
    filename: 'Vendor Export',
    no: (item) => {
      return item.customer.customer_no
    },
    full_name: (item) => {
      return item.customer.display_name
    },
    company_name: (item) => {
      return item.customer.company_name
    },
    email: (item) => {
      return item.customer.email
    },
    address: (item) => {
      return item.display_billing_address
    },
    financial_items: (item) => {
      return item.financial_items
    },
    total_lots_sold: (item) => {
      return item.total_lots_sold
    },
    total_lots_unsold: (item) => {
      return item.total_lots_unsold
    },
    total_financial_items_released: (item) => {
      return item.total_financial_items_released
    },
    identity_verification: (item) => {
      return (item.customer && item.customer.term) ? item.customer.term.identity_verification : ''
    },
  }

  transferNoteGetter = {
    filename: 'Transfer Notes Export',
    type: (item) => {
      return item.type
    },
    status: (item) => {
      return item.status
    },
    issue_date: (item) => {
      return item.issue_date ? Formatter.toDateTime(item.issue_date) : ''
    },
    arrival_date: (item) => {
      return item.arrival_date ? Formatter.toDateTime(item.arrival_date) : ''
    },
    service_provider: (item) => {
      return item.service_provider
    },
    title: (item) => {
      return item.title
    },
    note: (item) => {
      return item.note
    },
    rep_user: (item) => {
      return item.rep_user ? item.rep_user.display_name : ''
    },
    origin_item_location: (item) => {
      return item.origin_item_location ? item.origin_item_location.name : ''
    },
    destination_item_location: (item) => {
      return item.destination_item_location ? item.destination_item_location.name : ''
    },
    created_at: (item) => {
      return getCreatedData(item)
    },
    updated_at: (item) => {
      return getUpdatedData(item)
    },
    no: (item) => {
      return item.transfer_note_no
    },
    contract_status: (item) => {
      return item.contract_status
    },
  }

  dpvGetter = {
    filename: 'DPV History Export',
    sale_number: (item) => {
      return item.auction_number
    },
    sale_start_date: (item) => {
      let end_date = '';
      if (item.auction_end_date) {
        end_date = ' - ' + Formatter.toDateTime(item.auction_end_date)
      }
      return Formatter.toDateTime(item.auction_start_date) + end_date
    },
    buyer_number: (item) => {
      return item.buyer_number
    },
    buyer_full_name: (item) => {
      return item.buyer_full_name
    },
    invoice_number: (item) => {
      return item.invoice_number
    },
    dpv_no: (item) => {
      return item.dpv_no
    },
    total_hammer: (item) => {
      return item.total_hammer
    },
    description: (item) => {
      return item.description
    },
    created_at: (item) => {
      return Formatter.toDateTime(item.created_at)
    },
  };

  dpvLotsGetter = {
    filename: 'DPV Details Export',
    dpv_no: (item) => {
      return item.dpv.dpv_no
    },
    sale_number: (item) => {
      return item.dpv.auction_number
    },
    lot_number: (item) => {
      return item.lot_number
    },
    receipt_number: (item) => {
      return item.receipt_number
    },
    stock_number: (item) => {
      return item.stock_number
    },
    lot_title: (item) => {
      return item.lot_title
    },
    hammer_price: (item) => {
      return item.hammer_price
    },
    buyer_number: (item) => {
      return item.dpv.buyer_number
    },
    buyer_full_name: (item) => {
      return item.dpv.buyer_full_name
    },
    invoice_number: (item) => {
      return item.dpv.invoice_number
    },
    credit_note_number: (item) => {
      return item.dpv.credit_note_number
    },
    seller_number: (item) => {
      return item.seller_number
    },
    seller_full_name: (item) => {
      return item.seller_full_name
    },
    settlement_number: (item) => {
      return item.settlement_number
    },
    debit_note_number: (item) => {
      return item.debit_note_number
    },
  };

  preBidsGetter = {
    filename: 'Comm. & Tel. Bids Export',
    lot_no: (item) => {
      return item.lot_no
    },
    paddle_number: (item) => {
      return item.paddle_number
    },
    bidder: (item) => {
      return item.bidder && item.bidder.customer ? item.bidder.customer.display_name : ''
    },
    amount: (item) => {
      return item.amount
    },
    type: (item) => {
      return item.type
    },
    status: (item) => {
      return item.status
    },
    date: (item) => {
      return item.date ? Formatter.toDateTime(item.date) : ''
    },
    is_winner: (item) => {
      return item.is_winner ? 'true' : 'false'
    },
    clerk: (item) => {
      return item.clerk ? item.clerk.name : ''
    },
    extra_step: (item) => {
      return item.extra_step
    },
    phone: (item) => {
      return item.phone
    },
    phone2: (item) => {
      return item.phone2
    },
    description: (item) => {
      return item.description
    },
    created_at: (item) => {
      return Formatter.toDateTime(item.created_at)
    }
  }

  invoicePaymentsGetter = {
    filename: 'Invoice Payments Export',
    invoice_no: (item) => {
      return item.invoice.invoice_no
    },
    invoice_type: (item) => {
      return item.invoice.type
    },
    sale_no: (item) => {
      return item.invoice.auction ? item.invoice.auction.sale_no : ''
    },
    customer: (item) => {
      return item.invoice.customer.display_name
    },
    customer_no: (item) => {
      return item.invoice.customer.customer_no
    },
    payment_type: (item) => {
      return item.payment.type
    },
    amount: (item) => {
      return item.amount
    },
    method: (item) => {
      return item.payment.method
    },
    date: (item) => {
      return Formatter.toDate(item.payment.date)
    },
    bank_account: (item) => {
      return item.payment.bank_account
    },
    reference_number: (item) => {
      return item.payment.reference_number
    },
    description: (item) => {
      return item.payment.description
    },
    reconciled: (item) => {
      return !!item.payment.reconciled
    },
    comment: (item) => {
      return item.payment.comment
    },
    batch_info: (item) => {
      return item.payment.batch_payment ? `${item.payment.batch_payment.payment_no} - ${item.payment.batch_payment.status}` : ''
    },
    created_at: (item) => {
      return getCreatedData(item.payment)
    },
    updated_at: (item) => {
      return getCreatedData(item.payment)
    },
    branch: (item) => {
      return item.invoice.branch.name;
    },
  }

  settlementPaymentsGetter = {
    filename: 'Settlements Payments Export',
    settlement_no: (item) => {
      return item.settlement.settlement_no
    },
    settlement_type: (item) => {
      return item.settlement.type
    },
    sale_no: (item) => {
      return item.settlement.auction ? item.settlement.auction.sale_no : ''
    },
    customer: (item) => {
      return item.settlement.customer.display_name
    },
    customer_no: (item) => {
      return item.settlement.customer.customer_no
    },
    payment_type: (item) => {
      return item.payment.type
    },
    amount: (item) => {
      return item.amount
    },
    method: (item) => {
      return item.payment.method
    },
    date: (item) => {
      return Formatter.toDate(item.payment.date)
    },
    bank_account: (item) => {
      return item.payment.bank_account
    },
    reference_number: (item) => {
      return item.payment.reference_number
    },
    description: (item) => {
      return item.payment.description
    },
    reconciled: (item) => {
      return !!item.payment.reconciled
    },
    comment: (item) => {
      return item.payment.comment
    },
    batch_info: (item) => {
      return item.payment.batch_payment ? `${item.payment.batch_payment.payment_no} - ${item.payment.batch_payment.status}` : ''
    },
    check_number: (item) => {
      return item.check_number ? item.check_number : ''
    },
    check_status: (item) => {
      return item.check_status ? item.check_status : ''
    },
    batch_id: (item) => {
      return item.batch_id ? item.batch_id : ''
    },
    bacs_status: (item) => {
      return item.bacs_status ? item.bacs_status : ''
    },
    payee: (item) => {
      return item.payee ? item.payee : ''
    },
    beneficiary_relation: (item) => {
      return item.payment.beneficiary_relation ? item.payment.beneficiary_relation.related_customer.display_name : ''
    },
    created_at: (item) => {
      return getCreatedData(item.payment)
    },
    updated_at: (item) => {
      return getCreatedData(item.payment)
    },
    branch: (item) => {
      return item.settlement.branch.name;
    },
  }

  getExportDataByModuleName(moduleName, fields, items, currentVueComponent, dynamicFieldsKeys = null) {
    let getter = false

    if (moduleName === 'customer') {
      getter = this.customerGetter
    } else if (moduleName === 'receipts') {
      getter = this.receiptGetter
    } else if (moduleName === 'sales') {
      getter = this.salesGetter
    } else if (moduleName === 'inventory') {
      getter = this.inventoryGetter
    } else if (moduleName === 'invoices') {
      getter = this.invoiceGetter
    } else if (moduleName === 'settlements') {
      getter = this.settlementGetter
    } else if (moduleName === 'lots') {
      getter = this.lotGetter
    } else if (moduleName === 'bidders') {
      getter = this.bidderGetter
    } else if (moduleName === 'bids') {
      getter = this.bidGetter
    } else if (moduleName === 'vendors') {
      getter = this.vendorGetter
    } else if (moduleName === 'transferNotes') {
      getter = this.transferNoteGetter
    } else if (moduleName === 'dpv') {
      getter = this.dpvGetter;
    } else if (moduleName === 'dpvLots') {
      getter = this.dpvLotsGetter;
    } else if (moduleName === 'preBids') {
      getter = this.preBidsGetter
    } else if (moduleName === 'invoicePayments') {
      getter = this.invoicePaymentsGetter
    } else if (moduleName === 'settlementPayments') {
      getter = this.settlementPaymentsGetter
    }

    if (getter === false) {
      return false
    }

    this.currentVueComponent = currentVueComponent

    const dataArray = []

    let columnHeaders = []
    fields.forEach(f => {
      if (!f.exclude_from_export && f.key !== 'checkbox') {
        columnHeaders.push({key: f.key, displayLabel: f.label})
      }
    })

    for (let item of items) {
      let obj = {}
      for (let field of fields) {

        if (field.exclude_from_export || field.key === 'checkbox') {
          continue
        }

        let val = null;

        if (dynamicFieldsKeys && dynamicFieldsKeys.includes(field.key)) {
          val = getter.dynamicFieldGet(item, field);
        } else {
          val = getter.hasOwnProperty(field.key) ? getter[field.key](item) : '';
        }

        if (val === null) {
          val = ''
        }

        obj[field.key] = val
      }

      dataArray.push(obj)
    }

    let fieldSeparator = ','
    if (store.state && store.state.global && store.state.global.currentUser.csv_export_delimiter) {
      fieldSeparator = store.state.global.currentUser.csv_export_delimiter
      if (fieldSeparator === 'tab') {
        fieldSeparator = '\t'
      }
    }

    const csvConfig = mkConfig({
      fieldSeparator: fieldSeparator,
      useKeysAsHeaders: false,
      columnHeaders: columnHeaders,
      filename: `${getter.filename}_${Formatter.getCurrentDate("YYYYMMDDHHmmss")}`
    });
    const csv = generateCsv(csvConfig)(dataArray);
    download(csvConfig)(csv)

    this.currentVueComponent = null;

    return dataArray
  }

}


export default new ArtisioTableExportHelper();
